

// OPTIMIZED Translation Script - Prevents Page Not Responding/Jumping

// Helper: markers to prevent infinite loops
const TRANSLATED_MARKER = '__translated';

function getTranslation(text) {
  if (!text) return text;
  let originalText = text;

  // 1. Full Sentence Translations (Exact Match)
  const fullPhrases = {
    "Price is for the diamond only": "Il prezzo è per solo il diamante",
    "IGI Certified": "Certificato IGI",
    "GIA Certified": "Certificato GIA",
    "Only One Available": "Solo uno disponibile",
    "Sourced with Care": "Selezionato con cura",
    "Diamond details": "Dettagli del diamante",
    "Add diamond": "Aggiungi diamante",
    "Add Diamond": "Aggiungi Diamante",
    "Add to cart": "Aggiungi al carrello",
    "Please check our": "Perfavore controlla il nostro",
    "Back to browse": "Torna alla navigazione",
    "Ring Size Guide": "Guida alle misure degl'anelli",
    "Ring Size": "Misura anello",
    "Advanced Filters": "Filtri avanzati",
    "More Shapes": "Più forme",
    "Fewer Shapes": "Meno forme",
    "Setting only": "Solo montatura",
    "Select Setting": "Seleziona montatura",
    "Price: low to high": "Prezzo: crescente",
    "Price: high to low": "Prezzo: decrescente",
    "Carat: low to high": "Carati: crescente",
    "Carat: high to low": "Carati: decrescente",
    "Diamond Size": "Dimensione del diamante",
    "Ring Style": "Stile anello",
    "Completed Ring": "Anello completo",
    "Setting Variant": "Variante della montatura",
    "Not sure": "Non so",
    "Ring Size Region: Spain": "Regione misura: Spagna",
    "Diamond details": "Dettagli del diamante"
  };

  const trimmed = text.trim();
  if (fullPhrases[trimmed]) {
    return text.replace(trimmed, fullPhrases[trimmed]);
  }

  // 2. Shape + Type (Global Replacements)
  const shapeTranslations = {
    "ROUND": "Brillante", "PRINCESS": "Principessa", "OVAL": "Ovale", "SQUARE EMERALD": "Smeraldo Quadrato",
    "EMERALD": "Smeraldo", "CUSHION": "Cuscino", "ASSCHER": "Asscher", "RADIANT": "Radiante",
    "PEAR": "Goccia", "HEART": "Cuore", "MARQUISE": "Marquise",
    "Round": "Brillante", "Princess": "Principessa", "Oval": "Ovale", "Cushion": "Cuscino",
    "Asscher": "Asscher", "Radiant": "Radiante", "Pear": "Goccia", "Heart": "Cuore",
    "Marquise": "Marquise", "Square Emerald": "Smeraldo Quadrato", "Emerald": "Smeraldo"
  };

  // Check generic phrases containing shapes
  Object.entries(shapeTranslations).forEach(([enShape, itShape]) => {
     // Regex to match "Round Lab Grown Diamond" etc case-insensitively
     text = text.replace(new RegExp(`${enShape} Lab Grown Diamond`, 'gi'), `Diamante ${itShape} di Laboratorio`);
     text = text.replace(new RegExp(`${enShape} Natural Diamond`, 'gi'), `Diamante ${itShape} Naturale`);
  });

  // 3. Static Keywords (Word Boundaries)
  const staticTranslations = {
    "Price": "Prezzo", "Style": "Stile", "Shape": "Forma", "Metal": "Metallo", "Setting": "Montatura",
    "Lab Grown": "di Laboratorio", "Review": "Rivedi", 
    "Ring Style": "Stile anello", "Solitaire": "Solitario", "Diamond Shape": "Forma del diamante","Sort":"Ordina",
    "Complete Ring": "Anello completo", "Clarity": "Purezza", "Colour": "Colore", "Cut": "Taglio",
    "White": "Bianco", "Fancy": "Fantasia", "Carats": "Carati", "Carat": "Carato",
    "Type": "Tipo", "Depth": "Profondità", "Table": "Tavola", "Polish": "Lucidatura",
    "Fluorescence": "Fluorescenza", "Ratio": "Razio", "Symmetry": "Simmetria",
    "Certificate": "Certificato", "Measurements": "Misure", "Results": "Risultato",
    "Diamonds": "Diamanti", "Spain": "Spagna", "Description": "Descrizione",
    "List": "Elenco", "Diamond": "Diamante", "Variant": "Variante", "Choose a": "Scegli il tuo",
    "Complete your": "Completa il tuo", "Ring": "Anello", "Remove": "Rimuovi", "View": "Visualizza",
    "Your ring summary": "Riepilogo del tuo Anello", "Finger Size": "Misura dell'anello", "ring size": "misura"
  };

  Object.entries(staticTranslations).forEach(([en, it]) => {
    // Only replace whole words (avoiding replacing "Price" inside "Caprice")
    const regex = new RegExp(`\\b${en}\\b`, 'g');
    text = text.replace(regex, it);
  });

  return text;
}

function processNode(node) {
    if (!node) return;
    
    // 1. Text Nodes: Translate content
    if (node.nodeType === Node.TEXT_NODE) {
        if (node[TRANSLATED_MARKER]) return; // Skip if done
        
        const original = node.textContent;
        if (!original || !original.trim()) return; 

        const translated = getTranslation(original);
        
        if (original !== translated) {
            node.textContent = translated;
        }
        node[TRANSLATED_MARKER] = true; // Mark as done
    } 
    // 2. Element Nodes: Recurse
    else if (node.nodeType === Node.ELEMENT_NODE) {
        // Skip script/style tags
        if (node.tagName === 'SCRIPT' || node.tagName === 'STYLE') return;
        
        // Handling special "Price is for diamond only" element directly if text replacement didn't catch it
        if (node.classList && node.classList.contains('view-details-price-text')) {
             if (node.innerText.toLowerCase().includes('price is for the diamond only')) {
                  node.innerHTML = "Il prezzo è per solo il diamante";
                  node[TRANSLATED_MARKER] = true;
                  return; // Done with this element
             }
        }

        node.childNodes.forEach(processNode);
    }
}

// Main Init
function initTranslation() {
  // 1. Translate current state
  processNode(document.body);

  // 2. Watch for changes (Efficiently)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      // ONLY process Added Nodes
      mutation.addedNodes.forEach((node) => {
          processNode(node);
      });
      
      // Optional: If text changes dynamically in existing node
      if (mutation.type === 'characterData') {
          processNode(mutation.target);
      }
    });
  });

  observer.observe(document.body, { 
      childList: true, 
      subtree: true,
      characterData: true 
  });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTranslation);
} else {
    initTranslation();
}
